export default __webpack_public_path__ + "static/media/heart-footer.99d7e9cc.svg";